
import Vue, { PropType } from "vue";
import { DialogI } from "@/types/dialog";
import { Word } from "@/types/aiAssistant";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import AiAssistant from "@/components/aiAssistant/AiAssistant.vue";
import AiAssistantButton from "@/components/aiAssistant/AiAssistantButton.vue";
import AiAssistantInput from "@/components/aiAssistant/AiAssistantInput.vue";

export default Vue.extend({
  name: "AiAssistantDialog",
  components: {
    BaseDialog,
    AiAssistant,
    AiAssistantButton,
    AiAssistantInput,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  computed: {
    selectedWords(): Word[] {
      return this.$store.getters["aiAssistant/getSelectedWords"];
    },
    step(): number {
      return this.$store.getters["aiAssistant/getStep"];
    },
    showAiAssistantButton(): boolean {
      return !!this.selectedWords.length && this.step === 1;
    },
  },
});
